import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { api, type SessionUser } from "./api/client";
import { ProjectList } from "./components/ProjectList";
import { ProjectAdd } from "./components/ProjectAdd";
import { ProjectView } from "./components/ProjectView";
import { AdminPage } from "./components/AdminPage";
import { LoginButton } from "./components/LoginButton";
import "./styles/app.css";

export default function App() {
  const [user, setUser] = useState<SessionUser | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .me()
      .then((r) => setUser(r.user))
      .finally(() => setLoaded(true));
  }, []);

  return (
    <BrowserRouter>
      <div className="app-shell">
        <header className="app-header">
          <Link to="/" className="app-header__brand">
            🦑 Shoggoth Community
          </Link>
          <div className="app-header__right">
            {user?.role === "admin" && (
              <Link to="/admin" className="btn btn--ghost">
                Administration
              </Link>
            )}
            {loaded && <LoginButton user={user} onLoggedOut={() => setUser(null)} />}
          </div>
        </header>

        <div className="app-content">
          <Routes>
            <Route path="/" element={<ProjectList />} />
            <Route path="/projects/new" element={<ProjectAdd />} />
            <Route path="/projects/:id" element={<ProjectView user={user} />} />
            <Route path="/admin" element={<AdminPage user={user} />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}
